import * as React from "react";
import {Slot} from "@radix-ui/react-slot";
import {cva} from "class-variance-authority";
import {cn} from "./utils";
import "./ui.css";
import "./Button.module.css";

const buttonVariants = cva("ui-button", {
    variants: {
        variant: {
            default: "ui-button--variant-default",
            destructive: "ui-button--variant-destructive",
            outline: "ui-button--variant-outline",
            secondary: "ui-button--variant-secondary",
            ghost: "ui-button--variant-ghost",
            link: "ui-button--variant-link",
        },
        size: {
            default: "ui-button--size-default",
            sm: "ui-button--size-sm",
            lg: "ui-button--size-lg",
            icon: "ui-button--size-icon",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});

const Button = React.forwardRef(({
    className,
    variant,
    size,
    asChild = false,
    fullWidth = false,
    ...props
}, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
        <Comp
            data-slot="button"
            ref={ref}
            className={cn(buttonVariants({variant, size, className}), fullWidth && "ui-button--full-width")}
            {...props}
        />
    );
});

Button.displayName = "Button";

export {Button, buttonVariants};
